import { render, staticRenderFns } from "./OperationalPerformanceLeader.vue?vue&type=template&id=9a54c80c&scoped=true"
import script from "./OperationalPerformanceLeader.vue?vue&type=script&lang=ts"
export * from "./OperationalPerformanceLeader.vue?vue&type=script&lang=ts"
import style0 from "./OperationalPerformanceLeader.vue?vue&type=style&index=0&id=9a54c80c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a54c80c",
  null
  
)

export default component.exports